import {QuickEditEventFormValidationSchema} from '@/features/agenda/formSchemas'
import {InputSelectUser} from '@/features/users/components/input-select-user/InputSelectUser'
import {useTranslation} from '@/translations/i18n'
import {useController, useFormContext, useWatch} from 'react-hook-form'

export const AgendaSubstituteField = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<QuickEditEventFormValidationSchema>()
    const {field, fieldState} = useController({control, name: 'substitute'})
    const consultants = useWatch({control, name: 'consultants'})
    return (
        <InputSelectUser
            onClear={() => field.onChange(null)}
            label={t('agenda:substitute')}
            placeholder={t('commons:select')}
            value={field.value ?? null}
            onChange={field.onChange}
            errorMessage={fieldState.error?.message}
            filters={{
                status: 'operative',
                specializationId: [consultants?.[0]?.specializationId]
            }}
        />
    )
}
